import React from 'react';
import Box from '@mui/material/Box';
import {type Property} from 'csstype';

import {useBreakpoints} from 'modern-famly/theming';
import {useDataProps, type DataProps} from 'modern-famly/components/util';
import {map as mapResponsiveValue} from 'modern-famly/system/responsive-value';

import {type ListBreakpoint} from './use-list-media-query';
import {GridAreaName} from './shared';

type OptionalListBreakpoint = Exclude<ListBreakpoint, 'tabletPortrait'>;
type BreakpointsValueForLists<T> = {tabletPortrait: T} & {[B in OptionalListBreakpoint]?: T};

export type ListProps = {
    children?: React.ReactNode;
    gridTemplateColumns: BreakpointsValueForLists<Property.GridTemplateColumns> | Property.GridTemplateColumns;
} & DataProps;

export const List = (props: ListProps) => {
    const {isTabletPortraitAndLarger} = useBreakpoints();

    const dataProps = useDataProps(props);

    if (!isTabletPortraitAndLarger) {
        return null;
    }

    return (
        <Box
            sx={{
                width: '100%',
                display: 'grid',
                // We're "injecting" a grid area name here to make it possible to use subgrid in the ListRow component
                gridTemplateColumns: mapResponsiveValue(props.gridTemplateColumns, template => {
                    return `[${GridAreaName}-start] ${template} [${GridAreaName}-end]`;
                }),
                rowGap: '2px',
            }}
            {...dataProps}
        >
            {props.children}
        </Box>
    );
};
